/* Herb Garden welcome popup: email sign-up with a first-order code.
   Opens after the delay set in the theme editor, stays away for the snooze days once closed,
   and never shows again after sign-up. Add ?thg_popup=1 to any URL to open it for testing. */
(function () {
  var COOKIE = 'thg_wp';

  function getCookie() {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split('=');
      if (kv[0] === COOKIE) return decodeURIComponent(kv.slice(1).join('='));
    }
    return '';
  }
  function setCookie(value, days) {
    document.cookie = COOKIE + '=' + encodeURIComponent(value) + '; path=/; max-age=' + Math.round(days * 86400) + '; SameSite=Lax';
  }
  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init(root) {
    if (!root || root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');

    var box = root.querySelector('.thg-wp__box');
    var join = root.querySelector('.thg-wp__join');
    var done = root.querySelector('.thg-wp__done');
    var form = root.querySelector('form');
    var stateEl = root.querySelector('[data-wp-state]');
    var state = stateEl ? stateEl.getAttribute('data-wp-state') : 'idle';
    var code = root.getAttribute('data-code') || '';
    var delay = parseFloat(root.getAttribute('data-delay'));
    var snooze = parseFloat(root.getAttribute('data-snooze'));
    if (isNaN(delay)) delay = 5;
    if (isNaN(snooze) || snooze <= 0) snooze = 7;
    var lastFocus = null;
    var timer = null;
    var hideTimer = null;
    var open = false;
    if (!box || !join || !done) return;

    function focusables() {
      return Array.prototype.filter.call(
        box.querySelectorAll('a[href], button, input:not([type="hidden"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { hide(true); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function setStep(step) {
      var isDone = step === 'done';
      join.hidden = isDone;
      done.hidden = !isDone;
      box.setAttribute('aria-labelledby', isDone ? 'thg-wp-title-done' : 'thg-wp-title');
    }
    function show(step) {
      setStep(step);
      if (open) return;
      open = true;
      clearTimeout(timer);
      clearTimeout(hideTimer);
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('thg-wp-lock');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (open) root.classList.add('is-open'); });
      });
      document.addEventListener('keydown', onKey);
      // Focus the email field on desktop only, so phones don't throw the keyboard up unasked;
      // otherwise focus the dialog itself so screen readers announce it.
      var desktop = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var target = step !== 'done' && desktop ? root.querySelector('input[type="email"]') : null;
      setTimeout(function () {
        if (!open) return;
        try { (target || box).focus({ preventScroll: true }); } catch (err) {}
      }, 80);
    }
    function hide(remember) {
      if (!open) return;
      open = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('thg-wp-lock');
      document.removeEventListener('keydown', onKey);
      if (remember && getCookie() !== 'joined') setCookie('closed', snooze);
      hideTimer = setTimeout(function () { if (!open) root.hidden = true; }, 380);
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (err) {}
      }
    }
    // Puts the code on the visitor's cart so it is already there at checkout.
    function applyCode() {
      if (!code) return;
      var base = rootPath();
      try {
        fetch(base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(base + 'cart.js'), { credentials: 'same-origin' }).catch(function () {});
      } catch (err) {}
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-wp-close]')) { e.preventDefault(); hide(true); }
    });

    var copyBtn = root.querySelector('[data-wp-copy]');
    if (copyBtn) {
      var label = copyBtn.textContent;
      copyBtn.addEventListener('click', function () {
        function ok() {
          copyBtn.textContent = copyBtn.getAttribute('data-copied') || 'Copied';
          setTimeout(function () { copyBtn.textContent = label; }, 2000);
        }
        function fallback() {
          var t = document.createElement('textarea');
          t.value = code;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); ok(); } catch (err) {}
          document.body.removeChild(t);
        }
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(ok, fallback);
        else fallback();
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');
      });
    }

    // Theme editor: open while the section is selected, never on a timer.
    if (window.Shopify && window.Shopify.designMode) {
      var sid = root.getAttribute('data-section');
      var preview = root.getAttribute('data-preview') === 'done' ? 'done' : 'join';
      document.addEventListener('shopify:section:select', function (e) {
        if (!root.isConnected) return;
        if (e.detail && e.detail.sectionId === sid) { window.__thgWpOpen = true; show(preview); }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (!root.isConnected) return;
        if (e.detail && e.detail.sectionId === sid) { window.__thgWpOpen = false; hide(false); }
      });
      if (window.__thgWpOpen) show(preview);
      return;
    }

    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (err) {}
    function param(k) { return params ? params.get(k) : null; }
    var posted = param('customer_posted') === 'true';
    var ownPost = window.location.hash === '#thg-wp-form';

    // Just signed up (here, or with the footer or homepage form): show the code.
    if (state === 'done' || posted) {
      setCookie('joined', 365);
      applyCode();
      show('done');
      if (params && window.history && window.history.replaceState) {
        params.delete('customer_posted');
        var qs = params.toString();
        try { window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '')); } catch (err) {}
      }
      return;
    }
    // The popup's own form came back with an error: reopen it so the message is seen.
    if (state === 'error' && ownPost) { show('join'); return; }
    if (state === 'error') {
      var er = root.querySelector('.thg-wp__err');
      if (er && er.parentNode) er.parentNode.removeChild(er);
      var inp = root.querySelector('input[type="email"]');
      if (inp) { inp.removeAttribute('aria-invalid'); inp.removeAttribute('aria-describedby'); }
    }

    if (param('thg_popup') === '1') { show('join'); return; }
    var c = getCookie();
    if (c === 'joined' || c === 'closed' || root.getAttribute('data-subscribed') === '1') return;

    // Wait while the visitor is typing somewhere or has the menu open.
    function attempt() {
      var a = document.activeElement;
      var typing = a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a);
      var menu = document.querySelector('.fm-drawer.is-open');
      if (typing || menu) { timer = setTimeout(attempt, 3000); return; }
      show('join');
    }
    timer = setTimeout(attempt, Math.max(0, delay) * 1000);
  }

  function boot() { init(document.getElementById('thg-wp')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('#thg-wp') : null;
    if (r) init(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#thg-wp')) {
      document.documentElement.classList.remove('thg-wp-lock');
    }
  });
})();
